import { render, staticRenderFns } from "./ShapeEditorCanvas.vue?vue&type=template&id=2bc61ca1&scoped=true&"
import script from "./ShapeEditorCanvas.vue?vue&type=script&lang=js&"
export * from "./ShapeEditorCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ShapeEditorCanvas.vue?vue&type=style&index=0&id=2bc61ca1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc61ca1",
  null
  
)

export default component.exports